<app-login-layout [titulo]="titulo">
  <form
  autocomplete="off"
  class="loginForm ng-valid ng-dirty ng-touched"
  #formActivateUser="ngForm"
  novalidate
  [mustMatch]="['password', 'confirmPassword']"
  (ngSubmit)="formActivateUser.form.valid && onSubmit()"
>


<div class="loginPasswordBox">
  <div class="floatingLabelControl">

    <div class="floatingLabelContainer">
      <div
        class="horizontalLayout floatingLabel floatingLabelShown alignVerticalMiddle"
        id="labelLayout"
      >
        <label class="colAuto">Email</label>
      </div>
    </div>

    <div class="inputLabelContent" id="contentLayout">
      <input matInput [(ngModel)]="resetPasswordModel.Email" name="email" type="email" #emailInput= "ngModel" required/>

      <div *ngIf="formActivateUser.submitted && emailInput.invalid" class="invalid-feedback">
        <div *ngIf="emailInput.errors.required">El email es obligatorio</div>
        <div *ngIf="passwordInput.errors.email">El email indicado no es válido. </div>
    </div>
    </div>
  </div>
</div>

  <div class="loginPasswordBox">
    <div class="floatingLabelControl">

      <div class="floatingLabelContainer">
        <div
          class="horizontalLayout floatingLabel floatingLabelShown alignVerticalMiddle"
          id="labelLayout"
        >
          <label class="colAuto">Contraseña</label>
        </div>
      </div>

      <div class="inputLabelContent" id="contentLayout">
        <input
          matInput
          type="password"
          [(ngModel)]="resetPasswordModel.Password"
          name="password"
          #passwordInput= "ngModel"
          [pattern]="passwordPattern"
          [ngClass]="{ 'is-invalid': formActivateUser.submitted && passwordInput.invalid }" required />

        <div *ngIf="formActivateUser.submitted && passwordInput.invalid" class="invalid-feedback">
          <div *ngIf="passwordInput.errors.required">La contraseña es obligatoria</div>
          <div *ngIf="passwordInput.errors.pattern">La contraseña informada no es válida. Debe tener al menos 8 caracteres, contener al menos una letra minúscula, una letra mayúscula, un caracter especial y un número.</div>
      </div>
      </div>
    </div>
  </div>

  <div class="loginPasswordBox">
    <div class="floatingLabelControl">

      <div class="floatingLabelContainer">
        <div
          class="horizontalLayout floatingLabel floatingLabelShown alignVerticalMiddle"
          id="labelLayout"
        >
          <label class="colAuto">Confirmar contraseña</label>
        </div>
      </div>

      <div class="inputLabelContent" id="contentLayout">
        <input
          matInput
          type="password"
          [(ngModel)]="resetPasswordModel.ConfirmPassword"
          name="confirmPassword"
          #confirmPasswordInput= "ngModel"
          [ngClass]="{ 'is-invalid': formActivateUser.submitted && confirmPasswordInput.invalid }" required />
          <div *ngIf="formActivateUser.submitted && confirmPasswordInput.invalid" class="invalid-feedback">
              <div *ngIf="confirmPasswordInput.errors.required">La confirmación de la contraseña es obligatoria</div>
              <div *ngIf="confirmPasswordInput.errors.mustMatch">Las contraseñas deben coincidir</div>
          </div>
      </div>
    </div>
  </div>

  <div class="loginSesionButton">
    <div class="loginRecoveryPass">
      <span Recuperar contraseña></span>
    </div>
    <button class="buttonPrimary loadingAnimationButton" [className]="loading ? 'loadingAnimationButton' : ''" id="btnLogin" [disabled]="loading">
      <ng-container *ngIf="!loading">{{textButton}}</ng-container>
      <div class="loadingSpinner" *ngIf="loading"></div>
    </button>
  </div>
  </form>
</app-login-layout>
